import { createAction, props } from '@ngrx/store';
import { ILoaderActionPayload } from '../models/loader.model';
import { ProcedureStatusHistoryItemList, TimelineList } from '../../../api/models';
import { Time } from '@angular/common';
import { ProcedureControllerGetTimeline$Params } from '../../../api/functions';



export const timelineActions = {
  load: createAction('load/timeline/load', props<ProcedureControllerGetTimeline$Params>()),
  done: createAction('load/timeline/done', props<{ state: ILoaderActionPayload; data?: TimelineList }>()),
};
